import { render } from "./SinFooter.vue?vue&type=template&id=6217585b"
import script from "./SinFooter.vue?vue&type=script&lang=js"
export * from "./SinFooter.vue?vue&type=script&lang=js"

import "./SinFooter.vue?vue&type=style&index=0&id=6217585b&lang=css"

import exportComponent from "/Users/desarrollo/Documents/Proyectos/friax/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__